import { NewProductURLBottomSheet } from "@/components/create/product/NewProductURLBottomSheet";
import { AddProductToCollectionBottomSheet } from "@/components/products/bottom-sheets/AddProductToCollectionBottomSheet";
import { CreateProductDetailsBottomSheet } from "@/components/create/product/CreateProductDetailsBottomSheet";
import { useState } from "react";
import type { ProductDto, ScrapedProductDto } from "@wtf/shared";

export const CreateProductFlow = ({
  onClose,
  onProductCreated,
  hideAddToCollection = false,
  initialUrl,
}: {
  /** Close the entire create flow */
  onClose: () => void;
  /** Notify parent of newly created product ID */
  onProductCreated: (id: string) => void;
  /** Hide final add-to-collection sheet */
  hideAddToCollection?: boolean;
  /** Pre-filled URL to auto-scrape (from Share Extension) */
  initialUrl?: string;
}) => {
  // Bottom sheet opens on mount to allow auto-submit when initialUrl is provided
  const [newProductOpen, setNewProductOpen] = useState(true);
  const [editProductOpen, setEditProductOpen] = useState(false);
  const [addToCollectionOpen, setAddToCollectionOpen] = useState(false);
  const [scrapedData, setScrapedData] = useState<ScrapedProductDto | null>(null);
  const [createdProduct, setCreatedProduct] = useState<ProductDto | null>(null);

  const handleEditProductOpen = () => {
    setNewProductOpen(false);
    setEditProductOpen(true);
  };

  return (
    <>
      <NewProductURLBottomSheet
        open={newProductOpen}
        onClose={() => setNewProductOpen(false)}
        onEditProductOpen={handleEditProductOpen}
        onNewProductClose={onClose}
        onScraped={(data) => setScrapedData(data)}
        initialUrl={initialUrl}
      />
      {scrapedData && (
        <CreateProductDetailsBottomSheet
          productData={scrapedData}
          open={editProductOpen}
          onClose={() => setEditProductOpen(false)}
          onAddToCollectionOpen={() => setAddToCollectionOpen(true)}
          onNewProductClose={onClose}
          onProductCreated={(product: ProductDto) => {
            setCreatedProduct(product);
            if (hideAddToCollection) {
              // Skip add-to-collection sheet: close flow and navigate
              onClose();
              onProductCreated(product.id);
            }
          }}
        />
      )}
      {!hideAddToCollection && createdProduct && (
        <AddProductToCollectionBottomSheet
          open={addToCollectionOpen}
          onClose={() => setAddToCollectionOpen(false)}
          onNewProductClose={() => {
            onClose();
            onProductCreated(createdProduct!.id);
          }}
          productId={createdProduct.id}
        />
      )}
    </>
  );
};
